
import * as types from 'features/EventContainer/redux/types/ExportScheduleType';

const DEFAULT_EXPORT_EVENT_STATE = {
  
    ExportHeader:{
        eventName: 'Event Name',
        type: 'Type',
        date: 'Date (mm/dd/yyyy)',
        start_time: 'Start Time',
        end_time: 'End Time',
        panelName: 'Room / Table Location',
        teamNumber: 'Team Number',
        teamName: 'Team Name',
    },
    eventDetail: {
        eventId: '',
        eventName: '',
        start_date: '',
        end_date: '',
      },
    eventCereMony:{
        openCeremony:{
            eventId: '',
            eventName: '',
            type: '',
            id:'',
            scheduleId:'',
            date: '',
            start_time: '',
            end_time: '',
            teamNumber: '',
            teamName: '',
            panelId: '',
            panelName: '',
        },
        closeCeremony:{
            eventId: '',
            eventName: '',
            type: '',
            id:'',
            scheduleId:'',
            date: '',
            start_time: '',
            end_time: '',
            teamNumber: '',
            teamName: '',
            panelId: '',
            panelName: '',
        }
    },
    judgingSession:[{
        eventId: '',
        eventName: '',
        type: '',
        id:'',
        scheduleId:'',
        date: '',
        start_time: '',
        end_time: '',
        teamNumber: '',
        teamName: '',
        panelId: '',
        panelName: ''
    }],
    matchesSession:[{
        eventId: '',
        eventName: '',
        type: '',
        id:'',
        scheduleId:'',
        date: '',
        start_time: '',
        end_time: '',
        teamNumber: '',
        teamName: '',
        panelId: '',
        panelName: ''
    }],
    countNewJudgingPanel: {panelNames: [], count: 0},
    countNewMatchesPanel: {panelNames: [], count: 0},
    isLoadingSchedule: false,
    addScheduleImportList: [],
    csvScheduleImport: {
        successfullyInvited: [],
        notInvited: [],
      },
  }

  export default (state = DEFAULT_EXPORT_EVENT_STATE, action) => {
    const {type} = action;
    switch(type) {
        case types.SET_CLEAR_ALL_SESSION:
            {
            return DEFAULT_EXPORT_EVENT_STATE
            }
        case types.SET_EVENT_DETAIL:
        return {
            ...state,
            eventDetail: action.payload.eventDetail
        }
        case types.SET_EVENT_CEREMONY:
        return {
            ...state,
            eventCereMony: 
            {
            openCeremony:{
                ...action.payload.Ceremony.openCeremony              
            } , 
            closeCeremony: {
                ...action.payload.Ceremony.closeCeremony
            }
            },
        }   
        case types.SET_JUDGING_SESSION:
            return {
                ...state,
                judgingSession: action.payload.judgingSession
            }
        case types.SET_MATCHES_SESSION:
            return {
                ...state,
                matchesSession: action.payload.matchesSession
            }
        case types.SET_CLEAR_JUDGING_SESSION:
            return {
                ...state,
                judgingSession: DEFAULT_EXPORT_EVENT_STATE.judgingSession
            }

        case types.SET_CLEAR_MATCHES_SESSION:
            return {
                ...state,
                matchesSession: DEFAULT_EXPORT_EVENT_STATE.matchesSession
            }

        case types.SCHEDULE_BEGIN:
            return {
                ...state,
                isLoadingSchedule: true
            }
        case types.SCHEDULE_BEGIN_ERROR:
            return {
                ...state,
                isLoadingSchedule: false
            }
        case types.SCHEDULE_BEGIN_SUCCESS:
            return {
                ...state,
                isLoadingSchedule: false,
            }

        case types.SET_IMPORT_SCHEDULE:
            return {
                ...state,
                addScheduleImportList: action.payload.addScheduleImportList
            } 
    
        case types.SET_EVENT_SCHEDULE_INVITED:
            {
                const { successfullyInvited, notInvited } = action.payload;
                return {
                    ...state,
                   csvScheduleImport: {
                        ...state.csvScheduleImport,
                        successfullyInvited:successfullyInvited,
                        notInvited: notInvited,
                    },
                };
            }

        case types.SET_COUNT_NEW_JUDGING_PANEL:
            return {
                ...state,
                countNewJudgingPanel: {
                    ...state.countNewJudgingPanel,
                    panelNames: action.payload.countNewJudgingPanel.panelNames ,
                    count: action.payload.countNewJudgingPanel.count
                }             
            }

        case types.SET_COUNT_NEW_MATCHES_PANEL:

            return {
                ...state,
                countNewMatchesPanel: {
                    ...state.countNewMatchesPanel,
                    panelNames: action.payload.countNewMatchesPanel.panelNames ,
                    count: action.payload.countNewMatchesPanel.count
                }     
            }       
            
        case types.RESET_IMPORT_SCHEDULE_MODAL:
            return {
                ...state,
                countNewJudgingPanel: {panelNames: [], count: 0},
                countNewMatchesPanel: {panelNames: [], count: 0},
                isLoadingSchedule: false,
                addScheduleImportList: [],
                csvScheduleImport: {
                    successfullyInvited: [],
                    notInvited: [],
                },
            }  

        default:
            return state
    }
  }